import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@component/icon';

export const TYPE_ERROR = 'error';
export const TYPE_VALID = 'validated';
export const TYPE_WARNING = 'warning';
export const TYPE_INFO = 'info';

const FormNotification = ({ type, message }) => {
  if (!message) {
    return null;
  }

  const shouldShowIcon = type !== TYPE_WARNING && type !== TYPE_INFO;

  return (
    <div className={`form-notification form-notification--${type}`}>
      {shouldShowIcon && (
        <Icon
          type={type === TYPE_ERROR ? 'Error' : 'Valid'}
          className="form-notification__icon"
        />
      )}
      <span className="form-notification__message">{message}</span>
    </div>
  );
};

FormNotification.propTypes = {
  type: PropTypes.oneOf([TYPE_ERROR, TYPE_VALID, TYPE_WARNING, TYPE_INFO])
    .isRequired,
  message: PropTypes.node,
};

FormNotification.defaultProps = {
  type: TYPE_ERROR,
};

export default FormNotification;
